import { render, staticRenderFns } from "./additionalData.vue?vue&type=template&id=6436bc1a&"
import script from "./additionalData.vue?vue&type=script&lang=js&"
export * from "./additionalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports